module.exports = __webpack_public_path__ + "static/media/bubble.0f0c51cc.png";